import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import { SettingSidebar } from './setting-sidebar';
import { Box } from '@material-ui/core';

const useStyles = makeStyles({
  list: {
    width: 'max-content',
  },
});

export const SettingTemporarySidebar = ({ menuItems }) => {
  const classes = useStyles();
  const [state, setState] = useState();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState(open);
  };

  const ListItem = () => (
    <div
      className={classes.list}
      role='presentation'
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <SettingSidebar menuItems={menuItems} />
    </div>
  );

  return (
    <Box display='flex' alignItems='center'>
      <MenuRoundedIcon
        size='large'
        onClick={toggleDrawer(true)}
        startIcon={<MenuRoundedIcon />}
      />
      <Drawer anchor={'left'} open={state} onClose={toggleDrawer(false)}>
        <ListItem />
      </Drawer>
    </Box>
  );
};
